export const upper = <Lower extends string>(lower: Lower): Uppercase<Lower> =>
  lower.toUpperCase() as Uppercase<Lower>;
